// import domReady from "@wordpress/dom-ready";

// domReady(() => {
// 	const sidebar = document.querySelector(
// 		".wp-block-wedocs-fse-support-wedocs-sidebar",
// 	);
// 	const listItems = sidebar.querySelector(".doc-nav-list");
// 	const isScrollListItems =
//     sidebar?.getAttribute("data-scroll-list-items") === "true";
    
// 	const topOffset = listItems?.getBoundingClientRect().top;
// 	const height = `calc(100vh - ${topOffset}px)`;
    
// 	if (isScrollListItems) {
//         listItems.style.height = height;
//         console.log(height, listItems);
// 	}
// });
